import { pipe } from "fp-ts/lib/function"
import { POApi } from "../POApi"
import * as t from 'io-ts'
import { ZIO } from "@mxt/zio"
import { Maybe } from "@mxt/zio/codec"
export namespace OPLReportService {
  export const LetterTypeInfo = t.type({
    name: t.string
  })

  export const OPLReportRequest = t.type({
    start: t.number,
    size: t.number,
    sort: t.string,
    order: t.string,
    policyNum: t.string,
    clientName: t.string,
    letterType: t.string,
    fileName: t.string,
    printingDate: t.string,
  })

  export const OPLReportInfo = t.type({
    policyNum: t.string,
    clientName: Maybe(t.string),
    letterType: Maybe(t.string),
    fileName: t.string,
    printingDate: t.string
  })
  export type LetterTypeInfo = t.TypeOf<typeof LetterTypeInfo>
  export type OPLReportInfo = t.TypeOf<typeof OPLReportInfo>
  export type OPLReportRequest = t.TypeOf<typeof OPLReportRequest>

  export const getLetterTypeList = () => pipe(
    POApi.get('communication-rest/paperletter/letter-types', { headers: { 'content-type': 'application/json' } })(t.type({
      data: t.array(LetterTypeInfo)
    })),
    ZIO.map((reponse) => reponse.data)
  )

  export const getOPLReportList = (body: OPLReportRequest) => pipe(
    POApi.post(`communication-rest/paperletter/reports`)(t.type({
      total: t.number,
      data: t.array(OPLReportInfo)
    }))(body)
  )
}